import { Injectable } from "@angular/core";
import { LoginResult } from "@cotecna/session";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LoggingService } from "src/app/shared/logging/logging.service";
import { environment } from "src/environments/environment";

import { User } from "../models/user";
import { HttpService } from "./http.service";
const contentType = { "Content-Type": "application/json" };

@Injectable({
  providedIn: "root",
})
export class SessionService {
  public constructor(
    private http: HttpService,
    private loggingService: LoggingService,
  ) {}

  public externalLogin(loginResult: LoginResult): Promise<User> {
    const loginObject = {
      email: loginResult.email,
      password: loginResult.password,
    };
    return this.http
      .post(
        `${environment.webApiUrl}/api/authentication/login`,
        loginObject,
        contentType,
      )
      .pipe(
        map((response) => {
          return response;
        }),
      )
      .toPromise()
      .catch((error) => {
        console.log(error);
      });
  }

  public async externalLogout(): Promise<void> {
    await this.http
      .get(`${environment.webApiUrl}/api/authentication/logout`, {
        withCredentials: true,
      })
      .toPromise();
    this.loggingService.removeUserContext();
  }

  public forgotPassword(email: string): Observable<void> {
    return this.http.post(
      `${environment.webApiUrl}/api/authentication/forgotpassword`,
      { email, applicationName: "CoordinationModule" },
      contentType,
    );
  }
}
